import axios from 'axios';

export const HTTP = axios.create({
  baseURL: 'https://api.suplo.vn/v1',

})


// WEBPACK FOOTER //
// ./src/httpService/http-common.js